























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Unit from "../../../store/entities/unit";
@Component
export default class EditUnit extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  unit: Unit = new Unit();

  created() {}
  save() {
    (this.$refs.unitForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "unit/update",
          data: this.unit,
        });
        (this.$refs.unitForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.unitForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.unit = Util.extend(true, {}, this.$store.state.unit.editUnit);
    }
  }
  unitRule = {
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Name")),
        trigger: "blur",
      },
    ],
  };
}
